// removed by extract-text-webpack-plugin
module.exports = {"companyContactUs":"_1nJqTnsNwl3IpolZdh7bzg","wrapForm":"_2gyji4XX_BZn76PvdL-Pxf","submit":"m-69z2sqpIFWsaq7Froub","title":"_4Ojq6R9DdXuDuSBPBCAra","subtitle":"_3hTdFIDEEwHL0mkV4tkoi2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyContactUs/CompanyContactUs.scss
// module id = 1562
// module chunks = 0